import { useState, useEffect } from "react";
import Popup from "reactjs-popup";
import { CSVLink } from "react-csv";
import { BaseURL } from "../../Essentials/variables";
import MainHeader from "../../Components/MainHeader/MainHeader";
import "./style.scss"
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css' 
import axios from "axios";
import DumpDownload from "../../Components/DumpDownload/DumpDownloadPage";
function SumaryReportPage(props) {
  // const [rows,setRows]=useState();
  const [value, setValue] = useState(2);
  const [time, setTime] = useState(new Date());
  const [rowData,setRowData]=useState();
  const [showTable,setShowTable]=useState(false);
  const [isFetching,setIsFetching]=useState(0);
  
  const [message,setMessage]=useState("Select state wise or region wise data");
  const [rawData,setRawdata]=useState([
    { firstname: "Ahmed", lastname: "Tomi", email: "ah@smthing.co.com" },
    { firstname: "Raed", lastname: "Labes", email: "rl@smthing.co.com" },
    { firstname: "Yezzi", lastname: "Min l3b", email: "ymin@cocococo.com" }
  ]);
  const [optionSelection,setOptionSelection]=useState('state');
  const [rowDataColour,setRowDataColour]=useState('bg-[#171C8F] border-b table-rows dark:border-gray-700');
  const [rowDataTextColour,setRowDataTextColour]=useState("table-td-style px-6 py-2 font-medium text-gray-200 whitespace-nowrap dark:text-white");

  function getCurrentAndPreviousMonth() {
    const currentDate = new Date();
    const currentMonth = currentDate.getMonth();
    let previousMonth = currentMonth - 1;
    if (previousMonth < 0) {
      previousMonth = 11; 
    }
    const monthNames = [
      "January", "February", "March", "April", "May", "June", "July",
      "August", "September", "October", "November", "December"
    ];
    const currentMonthName = monthNames[currentMonth];
    const previousMonthName = monthNames[previousMonth];
    return {
      currentMonth: currentMonthName,
      previousMonth: previousMonthName
    };
  }
  const months = getCurrentAndPreviousMonth();

  const handledealerbuttonClick = () => {
    setValue(2);
  };
  const handleEmployeebuttonClick = () => {
    setValue(1);
  };
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, '0');
  const day = String(today.getDate()).padStart(2, '0');
  const fileName = `${optionSelection}_summary_${year}-${month}-${day}.csv`;

  let headers = [
    { label: "First Name", key: "firstname" },
    { label: "Last Name", key: "lastname" },
    { label: "Email", key: "email" }
  ];
  
  let data = [
    { firstname: "Ahmed", lastname: "Tomi", email: "ah@smthing.co.com" },
    { firstname: "Raed", lastname: "Labes", email: "rl@smthing.co.com" },
    { firstname: "Yezzi", lastname: "Min l3b", email: "ymin@cocococo.com" }
  ];

  let tableHeader=[
    { label: optionSelection, key: optionSelection },
    { label: "no_of_villages", key: "no_of_villages_as_per_census_2011" },
    { label: `cumulative_village_coverage_till_previous_year`, key: `cumulative_village_coverage_till_previous_year`},
    { label: `unique_villages_covered_till_${months.previousMonth}`, key: `unique_villages_covered_till_last_month` },
    { label: `repeat_villages_covered_till_${months.previousMonth}`, key: `repeat_villages_covered_till_last_month` },
    { label: `new_added_villages_till_${months.previousMonth}`, key: `new_added_villages_till_last_month` },
    { label: `cumulative_village_coverage_till_${months.previousMonth}`, key: `cumulative_village_coverage_till_last_month` },
    { label: `unique_villages_covered_${months.currentMonth}`, key: `unique_villages_covered_current_month` },
    { label: `repeat_villages_covered_${months.currentMonth}`, key: `repeat_villages_covered_current_month` },
    { label: `new_added_villages_${months.currentMonth}`, key: "new_added_villages_current_month" },
  ]
  //   region
// no_of_villages_as_per_census_2011
// cumulative_village_coverage_till_previous_year
// unique_villages_covered_till_last_month
// repeat_villages_covered_till_last_month
// new_added_villages_till_last_month
// cumulative_village_coverage_till_last_month
// unique_villages_covered_current_month
// repeat_villages_covered_current_month
// new_added_villages_current_month

const DifferentColour='bg-[#D8D8D8] border-b  table-rows dark:border-gray-700 text-align: center'
const DifferentFontCss='table-td-style px-6 py-2 font-large text-black font-bold whitespace-nowrap dark:text-white ';

  const buttonStyle = {
    backgroundColor: '#171C8F',
    border: 'none',
    color: 'white',
    padding: '10px 20px',
    textAlign: 'center',
    textDecoration: 'none',
    display: 'inline-block',
    fontSize: '16px',
    margin: '4px 2px',
    cursor: 'pointer',
  };
  function getClassName(region) {
    const containsIndia = region?.toUpperCase().includes("INDIA");
    const containsZone = region?.toUpperCase().includes("ZONE");
  
    if (containsIndia) 
    {
      return 'table-td-style px-6 py-2 text-sm text-black font-bold whitespace-nowrap dark:text-white';
    } 
    else if (containsZone) 
    {
      return 'table-td-style px-6 py-2 font-large text-black font-bold whitespace-nowrap dark:text-white ';
    } 
    // else if (containsZone) {
    //   return "ClassNameForZoneOnly";
    // } 
    else {
      return rowDataTextColour;
    }
  }
  

  // state_name
  // no_of_villages_as_per_census_2011
  // cumulative_village_coverage_till_previous_year
  // unique_villages_covered_till_last_month
  // repeat_villages_covered_till_last_month
  // new_added_villages_till_last_month
  // cumulative_village_coverage_till_last_month
  // unique_villages_covered_current_month
  // repeat_villages_covered_current_month
  // new_added_villages_current_month

  const handleStatewiseSummary = () =>{
    setIsFetching(1);
    setOptionSelection('state_name');
    let Token=localStorage.getItem('token')
    axios({
      method:'GET',
      headers:{
          "x-access-token":Token,
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Frame-Options': 'DENY',
          'Content-Security-Policy': "frame-ancestors 'none'",
          'Feature-Policy': "frame-ancestors 'none'"
      },
      withCredentials:false,    //https://dev.msilruralmaps.com/api/summary/state
      url:BaseURL+'summary/state',
      }).then((res)=>{
        setRawdata(res?.data)
        const rows = res?.data?.map((item) => (
          <tr className={(item.state_name.toUpperCase().includes("ZONE")) || (item.state_name.toUpperCase().includes("INDIA"))?DifferentColour:rowDataColour} key={item?.state_name}>
            <td className={getClassName(item?.state_name)}>{item?.state_name.toUpperCase()}</td>
            <td className={getClassName(item?.state_name)}>{item?.no_of_villages_as_per_census_2011}</td>
            <td className={getClassName(item?.state_name)}>{item?.cumulative_village_coverage_till_previous_year}</td>
            <td className={getClassName(item?.state_name)}>{item?.unique_villages_covered_till_last_month}</td>
            <td className={getClassName(item?.state_name)}>{item?.repeat_villages_covered_till_last_month}</td>
            <td className={getClassName(item?.state_name)}>{item?.new_added_villages_till_last_month}</td>
            <td className={getClassName(item?.state_name)}>{item?.cumulative_village_coverage_till_last_month}</td>
            <td className={getClassName(item?.state_name)}>{item?.unique_villages_covered_current_month}</td>
            <td className={getClassName(item?.state_name)}>{item?.repeat_villages_covered_current_month}</td>
            <td className={getClassName(item?.state_name)}>{item?.new_added_villages_current_month}</td>
          </tr>
        ));
        console.log(rawData);
        setRowData(rows);
        setIsFetching(0);
        setShowTable(true)
        setMessage("Table has been created below");
        // Dealerresult=res.data;
      })
  }

  const handleRegionwiseSummary = () =>{
    setIsFetching(1);
    setOptionSelection('region');
    let Token=localStorage.getItem('token')
    axios({
      method:'GET',
      headers:{
          "x-access-token":Token,
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Frame-Options': 'DENY',
          'Content-Security-Policy': "frame-ancestors 'none'",
          'Feature-Policy': "frame-ancestors 'none'"
      },
      withCredentials:false,    //https://dev.msilruralmaps.com/api/summary/state
      url:BaseURL+'summary/region',
      }).then((res)=>{
        setRawdata(res?.data)
        console.log(res?.data);

        const rows = res?.data?.map((item) => (
          <tr className={(item.region.toUpperCase().includes("ZONE")) || (item.region.toUpperCase().includes("INDIA"))?DifferentColour:rowDataColour} key={item?.region}>
            <td className={getClassName(item.region)}>{item?.region.toUpperCase()}</td>
            <td className={getClassName(item.region)}>{item?.no_of_villages_as_per_census_2011}</td>
            <td className={getClassName(item.region)}>{item?.cumulative_village_coverage_till_previous_year}</td>
            <td className={getClassName(item.region)}>{item?.unique_villages_covered_till_last_month}</td>
            <td className={getClassName(item.region)}>{item?.repeat_villages_covered_till_last_month}</td>
            <td className={getClassName(item.region)}>{item?.new_added_villages_till_last_month}</td>
            <td className={getClassName(item.region)}>{item?.cumulative_village_coverage_till_last_month}</td>
            <td className={getClassName(item.region)}>{item?.unique_villages_covered_current_month}</td>
            <td className={getClassName(item.region)}>{item?.repeat_villages_covered_current_month}</td>
            <td className={getClassName(item.region)}>{item?.new_added_villages_current_month}</td>
          </tr>
        ));
        console.log(rawData);
        setRowData(rows);
        setIsFetching(0);
        setShowTable(true)
        setMessage("Table has been created below");
        // Dealerresult=res.data;
      })
  }
////////////////////////////////////////////////////////////
  return (
    <div>
      <section
        style={{
          backgroundImage: " url(background.png)",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          backgroundAttachment:"fixed",
          minHeight:"100vh"
        }}
      >
        <MainHeader profileVisiblilty={false} nav={props.nav}/>

        <div className="grid grid-cols-5 gap-4 py-6 rounded-md border-t-2">
          <div className="opacity-95 bg-gradient-to-b  text-center mr-auto rounded-md px-28 py-28">
            <div className="text-center mx-auto">
              <div className="button-container">
                <button onClick={handledealerbuttonClick} className="button mb-16">Dump Download</button>
              </div>
            </div>
            
            <div className="button-container">
                <button onClick={handleEmployeebuttonClick} className="button">Summary Download</button>
              </div>
          </div>
          <div className="col-span-4 text-center mx-auto">
            {value===0 &&
                <h4 className="text-slate-200 py-12">Please select download type.</h4>
              }
            {value === 1 && (
             
              <section className="text-center mx-auto my-10">
                <h1 className=" items-center  text-2xl font-semibold text-slate-200">
            <h1 className="text-3xl font-mono mb-4">Summary download </h1>
          </h1>
                <div className="grid grid-cols-2 gap-8">
                  <div onClick={handleStatewiseSummary} className="box1">
                  <img className="location_svg" src="summary_location.svg" alt="SVG Image" />
                    <p className="box_text">State Wise</p>
                  </div>

                  <div onClick={handleRegionwiseSummary} className="box2">
                  <img className="location_svg" src="summary_location.svg" alt="SVG Image" />
                    
                    <p className="box_text">Region Wise</p>
                  </div>
                  <div className="col-span-2 ">
                    {/* <button className="download-button">Download</button> */}
                    <h6 className="text-slate-200">{message}</h6>
                    {showTable && <CSVLink data={rawData} headers={tableHeader} filename={fileName}>
                       <button style={buttonStyle}>Download CSV</button>
                   </CSVLink>}
                  </div>
                </div>
                {/* <h1 className=" items-center mb-2 text-2xl font-semibold text-slate-200">
                  <h1 className="text-3xl font-mono pt-8">Summary download </h1>
                </h1>
                <div className="pt-8 my-8 items-center ">
                  <div className=" bg-white rounded-lg shadow dark:border dark:bg-gray-800">

                    <div className="">
                      <select className="block w-full   bg-white border border-gray-300 rounded px-28 py-1 leading-tight focus:outline-none focus:border-blue-500">
                        <option> Select FY-Year</option>
                      </select>

                    </div>
                  </div>
                </div>
                <button className="bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold py-2 px-4 rounded inline-flex items-center">
                  <svg className="fill-current w-4 h-4 mr-2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M13 8V2H7v6H2l8 8 8-8h-5zM0 18h20v2H0v-2z" /></svg>
                  <span>Download</span>
                </button> */}
              </section>
            )}

            {/* //////Dealer////// */}
            {value === 2 && <DumpDownload/>}
          </div>
        </div>
        <div className="px-4">
        {isFetching===1 &&  <SkeletonTheme baseColor="#171C8F" highlightColor="#444">
            <p>
              <Skeleton style={{ animationDuration: '0.5s' }} count={10}/>
            </p>
         </SkeletonTheme>}
      {value === 1 && isFetching===0 && showTable && (<table className=" table-auto mb-2 overflow-y-scroll w-full text-left text-gray-500 dark:text-gray-400">
            {<thead className="table-td-style table-heading text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
              <tr className="table-td-style bg-[#D8D8D8] border-b  dark:border-gray-700 ">
                <th className="px-6 py-3 font-bold text-black whitespace-nowrap dark:text-white">{optionSelection}</th>
                <th className="multiline-header px-6 py-3 font-bold text-black whitespace-nowrap dark:text-white">No. of Villages Census 2011</th>
                <th className="multiline-header px-6 py-3 font-bold text-black whitespace-nowrap dark:text-white">Cummulitive village coverage till Previous Year</th>
                <th className="multiline-header px-6 py-3 font-bold text-black whitespace-nowrap dark:text-white">unique villages covered till {months.previousMonth}</th>
                <th className="multiline-header px-6 py-3 font-bold text-black whitespace-nowrap dark:text-white">Repeat Villages Covered Till {months.previousMonth}</th>
                <th className="multiline-header px-6 py-3 font-bold text-black whitespace-nowrap dark:text-white">New Added Villages Till {months.previousMonth}</th>
                <th className="multiline-header px-6 py-3 font-bold text-black whitespace-nowrap dark:text-white">cumulative village coverage till {months.previousMonth}</th>
                <th className="multiline-header px-6 py-3 font-bold text-black whitespace-nowrap dark:text-white">unique villages covered {months.currentMonth}</th>
                <th className="multiline-header px-6 py-3 font-bold text-black whitespace-nowrap dark:text-white">repeat villages covered {months.currentMonth}</th>
                <th className="multiline-header px-6 py-3 font-bold text-black whitespace-nowrap dark:text-white">new added villages {months.currentMonth}</th>
              </tr>
            </thead>}
            <tbody className="h-fit">
              {/* {!showPopup && isFetching && <Skeleton />}
              {!showPopup && rows} */}
              {rowData}
             
            </tbody>
          </table>)}
      </div>
      </section>
      
    </div>
  );
}
export default SumaryReportPage;

  // state_name
  // no_of_villages_as_per_census_2011
  // cumulative_village_coverage_till_previous_year
  // unique_villages_covered_till_last_month
  // repeat_villages_covered_till_last_month
  // new_added_villages_till_last_month
  // cumulative_village_coverage_till_last_month
  // unique_villages_covered_current_month
  // repeat_villages_covered_current_month
  // new_added_villages_current_month
